import { useTrackPlaying } from "@/hooks/useTrackPlaying/useTrackPlaying";
import { PlayerSpeakerSegment } from "../PlayerSpeakerSegment/PlayerSpeakerSegment";

import { PlayerSpeakerTimelineProps } from "./PlayerSpeakerTimeline.decl";
import * as S from "./PlayerSpeakerTimeline.styled";

export function PlayerSpeakerTimeline({
  segments,
  color,
  call,
}: PlayerSpeakerTimelineProps) {
  const onClick = useTrackPlaying("utterance_bar");

  function handleClick(segmentIndex: number) {
    const channel =
      call?.transcription?.content?.utterances?.[segmentIndex]?.channel;

    if (!channel) {
      return;
    }

    const isAgent = call?.speakers?.get(channel)?.agentID;
    const sentiment = call?.utteranceSentiments?.get(segmentIndex)?.value;

    onClick({
      sentimentAtPlay: sentiment,
      // Right now if you have sentiments, it can only be "customer" `/src/states/call/utterance_sentiments/utterance_sentiments.utility.ts`
      utteranceSpeaker: isAgent ? "agent" : "customer",
    });
  }

  return (
    <S.Timeline data-test="speaker-audio-bar">
      {segments.map(({ startTime, left, width, index }) => (
        <PlayerSpeakerSegment
          index={index}
          key={startTime}
          startTime={startTime}
          color={color}
          left={left}
          width={width}
          call={call}
          onClick={handleClick}
        />
      ))}
    </S.Timeline>
  );
}
